import { render, staticRenderFns } from "./paperarrive.vue?vue&type=template&id=42c8f469&scoped=true&"
import script from "./paperarrive.vue?vue&type=script&lang=js&"
export * from "./paperarrive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8f469",
  null
  
)

export default component.exports